<template>
    <div name="use20240808">
        <h1> 개인정보 수집 이용 제공 동의 항목</h1>

솔닥 주식회사는 비대면 진료 서비스 제공을 위하여 아래와 같이 개인정보를 수집·이용하고자 합니다. 내용을 자세히 읽으신 후 동의 여부를 결정하여 주세요.<br/><br/>

<strong>개인정보 수집ᆞ이용</strong><br/><br/>

<table border="1">
  <tr>
    <th>수집ᆞ이용 목적</th>
    <th>항목</th>
    <th>보유ᆞ이용기간</th>
  </tr>
  <tr>
    <td>솔닥 비대면 진료 “바로돌봄” 서비스 제공</td>
    <td>이름, 생년월일, 성별</td>
    <td rowspan="2">소속 시설 퇴소 (계약 해지, 탈퇴) 시까지</td>
  </tr>
  <tr>
    <td>비대면 진료 서비스 제공에 따른 결제 서비스 제공</td>
    <td>결제 카드 정보(카드사, 카드번호, 카드 비밀번호 앞 2자리, 유효기간)</td>
  </tr>
</table><br/>

위의 개인정보 수집ᆞ이용에 대한 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우, 비대면 진료 서비스 이용에 제한을 받을 수 있습니다.<br/><br/>

<strong>개인정보 제3자 제공</strong><br/><br/>

<table border="1">
  <tr>
    <th>제공받는자</th>
    <th>이용 목적</th>
    <th>제공하는 항목</th>
    <th>보유ᆞ이용기간</th>
  </tr>
  <tr>
    <td>솔닥 제휴 의료진</td>
    <td>비대면 진료 서비스 제공 및 확인</td>
    <td>이름, 생년월일, 성별, 결제 카드 정보</td>
    <td rowspan="3">소속 시설 퇴소 (계약 해지, 탈퇴) 시까지</td>
  </tr>
  <tr>
    <td>솔닥 제휴 약국</td>
    <td>약 배송 서비스 제공 및 확인</td>
    <td>이름, 생년월일, 성별, 결제 카드 정보</td>
  </tr>
  <tr>
    <td>결제 대행사 (NHN 한국사이버결제㈜, ㈜케이지이니시스, 토스페이먼츠㈜)</td>
    <td>전자결제 신청</td>
    <td>결제 카드 정보</td>
  </tr>
</table><br/>

위의 개인정보 제공에 대한 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우, 비대면 진료 서비스 이용에 제한을 받을 수 있습니다.<br/><br/>

    </div>
</template>

<script>
export default {
    name: 'use20240808'
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/pages/barocare/contents/use/20240808.vue